import {RewardsConfigResponse} from "@/app/_api/types/rewards";
import {HttpConfig, HttpResponse} from "@/Fwk/Http/HttpConfig";
import {comRequest} from "@/Fwk/Http/comRequest";

type GetRewardsConfigParams = {
    rewardSource: number
}
export async function getRewardsConfig(params: GetRewardsConfigParams) {
    const config: HttpConfig = {
        url: `/hs-apis/acct/v1.0/reward/get_config`,
        method: "POST",
        body: params
    }
    const response = await DoSendRequest<RewardsConfigResponse>(config);
    return response.data;
}

type RewardsApplyParams = {
    rewardSource: number,
    userId: number
}
export async function rewardsApply(params: RewardsApplyParams) {
    const config: HttpConfig = {
        url: `/hs-apis/acct/v1.0/reward/apply`,
        method: "POST",
        body: params
    }
    const response = await DoSendRequest<boolean>(config);
    return response.data;
}

export async function DoSendRequest<T>(config: HttpConfig): Promise<HttpResponse<T>> {
    config.isSerErrTips = true;
    const sendRequest = await comRequest<T>(config);
    return sendRequest;
}

